<template>
  <div class="c-address c-address--saved u-margin-bottom-small">
    <div
      v-if="!active"
      class="c-address__info"
    >
      <slot name="info" />
    </div>
    <div
      v-else
      class="c-address__form u-margin-bottom-small"
    >
      <slot name="form" />
    </div>
  </div>
</template>

<script>
import Address from '../../mixins/address';
export default {
  name: 'AccountSavedAddress',
  mixins: [
    Address
  ],
  props: {
    id: {
      type: String,
      default: '',
    },
  },
  watch: {
    active() {
      this.$nextTick(() => {
        if (this.active) {
          // wait for component to completely render
          // eslint-disable-next-line no-undef
          if (!Shopify || !Shopify.CountryProvinceSelector) {
            console.error('Shopify Customer Area script not found.');
            return;
          }
          // eslint-disable-next-line no-undef, no-unused-vars
          const provinceSelector = new Shopify.CountryProvinceSelector(
            `AddressCountry_${this.id}`,
            `AddressProvince_${this.id}`,
            { hideElement: `AddressProvinceWrapper_${this.id}` },
          );
        } else {
          this.addListeners();
        }
      });
    },
  },
  mounted() {
    this.addListeners();
  },
  methods: {
    addListeners() {
      this.$nextTick(() => {
        const show = this.$el.querySelector('[data-show]');
        const del = this.$el.querySelector('[data-delete]');

        if (show && del) {
          show.addEventListener('click', this.showForm);
          del.addEventListener('click', this.destroyAddress);
        }
      });        
    },
    destroyAddress() {
      // eslint-disable-next-line no-undef
      if (!Shopify || !Shopify.CustomerAddress) {
        console.error('Shopify Customer Area script not found.');
        return;
      }
      // eslint-disable-next-line no-undef, no-unused-vars
      Shopify.CustomerAddress.destroy(this.id, 'Are you sure you wish to delete this address?');
    },
  },
};
</script>

<style lang="scss" scoped>
.c-address--saved {
  @include themify($themes) {
    border-bottom: $border themed('foreground', 'select');
  }
}
</style>